const objectAssign = require('object-assign');

let globals = {};
const $ = window;

globals.times = x => f => {
  if (x > 0) {
    f();
    globals.times(x - 1)(f)
  }
};

globals.isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
};

globals.mergeDeep = (target, source) => {
  let output = objectAssign({}, target);
  if (target === null) {
    target = {};
  }
  if (globals.isObject(target) && globals.isObject(source)) {
    Object.keys(source).forEach(key => {
      if (globals.isObject(source[key])) {
        if (!(key in target)) {
          objectAssign(output, { [key]: source[key] });
        } else {
          if (Object.keys(source[key]).length === 0) {
            objectAssign(output, { [key]: source[key] });
          } else {
            output[key] = globals.mergeDeep(target[key], source[key]);
          }
        }
      } else {
        objectAssign(output, { [key]: source[key] });
      }
    });
  }
  return output;
};

globals.sortByKey = (array, key, type) => {
  if (array instanceof Array) {
    return array.sort(function (a, b) {
      var aVal = a[key];
      var bVal = b[key];
      if (typeof aVal === "string") {
        aVal = a[key] !== undefined ? (a[key]).toUpperCase() : a[key];
      }
      if (typeof bVal === "string") {
        bVal = b[key] !== undefined ? (b[key]).toUpperCase() : b[key];
      }
      var x = aVal; var y = bVal;

      if (type === undefined || (type === null && type === "") || type === "asc") {
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      } else {
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
    });
  }
}

globals.clearSpace = (str) => {
  return str.replace(/ /g, '');
}

globals.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

globals.debounce = (func, wait) => {
  return globals.debounceWithImmediate(func, wait).wait;
}

globals.debounceWithImmediate = (func, wait) => {
  var timeout;
  return {
    wait: function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, wait);
    },
    now: function () {
      clearTimeout(timeout);
      timeout = null;
      func.apply(this, arguments);
    }
  }
}

globals.unixTimeToDurationStr = (unixTime) => {
  var t = Number(unixTime);
  var days = Number(t / 86400);
  t -= (days * 86400);

  var hours = Number(t / 3600);
  t -= (hours * 3600);

  var minutes = Number(t / 60);
  t -= (minutes * 60);
  var content = "";
  if (days) content += days + " days";

  if (hours || days) {
    if (content) content += ", "; content += hours + " hours";
  }

  if (content) content += ", "; content += minutes + " minutes";

  return content;
}

globals.unixTimeToStr = (unixTime) => {
  var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var date = new Date(unixTime * 1000);
  var year = date.getFullYear();
  var month = months_arr[date.getMonth()];
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = "0" + date.getMinutes();
  var seconds = "0" + date.getSeconds();
  var convdataTime = month + '-' + day + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

  return convdataTime;
}

globals.hexToRGB = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}


globals.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + s4() + s4() + s4() + s4();
};

globals.uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};

globals.roughSizeOfObject = function (object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;
  var loops = 0;

  while (stack.length && loops < 100000) {
    var value = stack.pop();
    if (typeof value === 'boolean') {
      bytes += 4;
    } else if (typeof value === 'string') {
      bytes += value.length * 2;
    } else if (typeof value === 'number') {
      bytes += 8;
    } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value);
      for (var i in value) {
        stack.push(value[i]);
      }
    }
    loops++;
  }
  return bytes;
};

globals.humanFileSize = function (bytes, si) {
  var thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }
  var units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + ' ' + units[u];
};

globals.productTitle = function () {
  return "Atlona Velocity | ";
};

globals.toTitleCase = function (str) {
  return str.replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
};

globals.camelize = function (str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '').replace(/[^\w\s]/gi, '');
};

globals.isEmpty = function (o) {
  let ret = false;
  if (globals.typeof(o) === "Null" || globals.typeof(o) === "Undefined") {
    ret = true;
  }
  return ret;
}

globals.typeof = function (o) {
  let typeInfo = "";
  if (o !== null && o !== undefined) {
    typeInfo = o.constructor.name; // returns Array, Boolean, Object, String, etc...
  } else if (o === null) {
    typeInfo = "Null";
  } else if (o === undefined) {
    typeInfo = "Undefined";
  }
  return typeInfo;
};

globals.touchAndClick = function (cb, useOnTouchTap = false) {
  let props = {};
  if ('ontouchstart' in $) {
    props = {}
    // for ListItem in materialUI, onTouchStart does not fire, but onTouchTap does,
    // if we had output this on everything, two events would fire so we need to conditionally add this in
    props.onTouchStart = (e) => {
      cb(e);
    }
  } else {
    props = {
      onClick: (e) => {
        cb(e);
      }
    }
  }
  return props;
}

globals.HexToAscii = function(str1) {
  var hex  = str1.toString();
  var str = '';
  for (var n = 0; n < hex.length; n += 2) {
    str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
  }
  return str;
}

globals.SubstituteASCIIHex = function(value) {
  var returnValue = "";
  var j = 0;
  if (value === undefined) {
    return value
  }
  for (j = 0; j < value.length; j++) {
    var ch = value.charCodeAt(j);
    if (ch === 92) { //Checking for \x
      if (value.length > j+1) {
        var chX = value.charCodeAt(j+1);
        // session_functions.VelocityDump(ch, chX);
        if (chX === 120) {
          if (value.length >= j+4) {
            var hexString = value.substring(j+2, j+4);
            returnValue += String.fromCharCode(parseInt(hexString, 16));
            j += 3
          }
        }
      }
    } else {
      returnValue += value[j]
    }
  }
  return returnValue;
}

globals.validateIPaddress = function (ipaddress) {
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
    return true;
  }
  return false;
}

globals.createMark = function (name) {
  if (performance.mark === undefined) {
    console.log("performance.mark Not supported");
    return;
  }
  // Create the performance mark
  performance.mark(name);
};

globals.endMark = function (originalMark) {
  if (performance.mark === undefined) {
    console.log("performance.mark Not supported");
    return;
  }

  globals.createMark("done-" + originalMark);
  $.performance.measure('diff-' + originalMark, originalMark, "done-" + originalMark);
  console.info("mark for " + originalMark + " executed in " + $.performance.getEntriesByName('diff-' + originalMark)[0].duration + 'ms');
  performance.clearMeasures(originalMark);
  performance.clearMeasures("done-" + originalMark);
  performance.clearMeasures('diff-' + originalMark);
};

globals.ObjectId = function () {
  var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
    return (Math.random() * 16 | 0).toString(16);
  }).toLowerCase();
};

globals.GetVar = function (name, url) {
  if (!url) {
    url = $.location.href;
  }
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

globals.isArray = function (pointer) {
  return (pointer !== undefined && pointer !== null && Array.isArray(pointer))
};

globals.filter = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.filter(mapFunc);
  }
};

globals.reduce = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.reduce(mapFunc);
  }
};

globals.forEach = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    pointer.forEach(mapFunc);
  } else if (globals.typeof(pointer) === "Object") {
    Object.keys(pointer).forEach((key) => {
      mapFunc(pointer[key], key);
    });
  }
};

globals.indexOf = function (pointer, searchValue, start) {
  if (globals.typeof(pointer) === "String") {
    return pointer.indexOf(searchValue, start);
  } else {
    return -1;
  }
};

globals.length = function (pointer) {
  if ((globals.isArray(pointer) || globals.typeof(pointer) === "String") && pointer !== undefined) {
    return pointer.length;
  } else if (globals.typeof(pointer) === "Object") {
    return Object.keys(pointer).length;
  } else {
    return 0;
  }
};

globals.map = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.map(mapFunc);
  } else if (globals.typeof(pointer) === "Object") {
    return Object.keys(pointer).map((key) => {
      return mapFunc(pointer[key], key);
    });
  }
};

globals.filter = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.filter(mapFunc);
  }
};

globals.findIndex = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.findIndex(mapFunc);
  }
};

globals.reduceRight = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.reduceRight(mapFunc);
  }
};

globals.some = function (pointer, mapFunc) {
  if (globals.isArray(pointer)) {
    return pointer.some(mapFunc);
  }
};

globals.__ = function (tpl, replacements) {
  return globals._(tpl, replacements);
};

globals._ = function (tpl, replacements) {
  if (typeof (tpl) === "undefined") {
    return tpl;
  }
  globals.forEach(replacements, function (k, v) {
    tpl = tpl.replace("{" + v + "}", k);
  });
  return tpl;
};

export default globals;


// WEBPACK FOOTER //
// ./src/components/system/globals.js